import { track } from '@bnnvara/analytics/src/track';
import React from 'react';

import * as S from '../styled';

const HomeButton = () => (
  <S.LeftMenuButton
    type="link"
    href="/"
    variant="text"
    onClick={() => {
      track('bnnvara-menu', 'click', 'home');
    }}
  >
    Home
  </S.LeftMenuButton>
);

export { HomeButton };
